
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"34","height":"34","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4.1 23.5v6.4h25.8V4.1H4.1v6.4","stroke":"#47AEA6","stroke-width":"2","stroke-miterlimit":"10","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M19.9 16.5l-2.6-3c-.4-.6-1-.6-1.5-.3-.4.4-.5 1-.1 1.4l1.2 1.3H4.3c-.6 0-1 .5-1 1s.5 1 1 1h12.6l-1.2 1.3c-.4.4-.3 1 .1 1.4.2.2.4.2.7.2.3 0 .6-.1.8-.3l2.6-3c0-.1.1-.1.1-.2v-.6c0-.1-.1-.1-.1-.2z","fill":"#F9A91E"}})])
          )
        }
      }
    